// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"SameShopPreview_style_carouselWrapper__2ZwnJ"};